import React from "react"

import BaseSvgIcon from "../Base"

const ExternalLink = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 17 16">
    <path
      d="M2.21429 16C1.74286 16 1.33929 15.8321 1.00357 15.4964C0.667857 15.1607 0.5 14.7571 0.5 14.2857V1.71429C0.5 1.24286 0.667857 0.839286 1.00357 0.503572C1.33929 0.167858 1.74286 0 2.21429 0H8.5V1.71429H2.21429V14.2857H14.7857V8H16.5V14.2857C16.5 14.7571 16.3321 15.1607 15.9964 15.4964C15.6607 15.8321 15.2571 16 14.7857 16H2.21429ZM6.28571 11.4286L5.07143 10.2143L13.5714 1.71429H10.7857V0H16.5V5.71429H14.7857V2.92857L6.28571 11.4286Z"
      fill="black"
    />
  </BaseSvgIcon>
)

export default ExternalLink
